import { IInfoBlockItem } from "shared/types";

export const getInfoBlockItemReadableName = (type: IInfoBlockItem) => {
  switch (type) {
    default:
    case IInfoBlockItem.contact: {
      return "contact";
    }
    case IInfoBlockItem.place: {
      return "place";
    }
    case IInfoBlockItem.file: {
      return "file";
    }
    case IInfoBlockItem.image: {
      return "image";
    }
  }
};
